/* eslint @typescript-eslint/naming-convention: 0 */
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export interface SearchZeroResultParams {
  /** PII ガード済みの入力キーワード（正規化後。送信抑止時は空文字） */
  keyword: string;
}

const buildSearchZeroResultParams = (keyword: string): SearchZeroResultParams => {
  return { keyword };
};

/**
 * 発火タイミング：検索結果が 0 件で確定した際（ダッシュボード⑤ゼロヒットの素材）
 */
export const sendGAWabunkaSearchZeroResultEvent = (keyword: string) => {
  sendWabunkaGAEvent('search_zero_result', buildSearchZeroResultParams(keyword));
};
